// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2cIDY","buttons":"Footer_buttons__3aemD"};